import React, {useState} from "react";
import {useTranslation} from "react-i18next";
import styles from "./GiftBlock.module.scss";
import {getShopId} from "../lib/getShopId";
import {Tracking} from "../../tracking/tracking";

const GiftBlock: React.FC = () => {
  const {t} = useTranslation();
  const [infoOpen, setInfoOpen] = useState(false);

  const href = document.querySelector("div[data-swiper-slide-index='0' ] > a")?.getAttribute("href");
  const imgRegExp = href?.match("/media/.+.jpg");
  let imgURL = "";
  if (imgRegExp) {
    imgURL = encodeURIComponent("https://connox.imgix.net" + imgRegExp[0]);
  }
  const productName = encodeURIComponent(document.querySelector(".product-details > h1")?.innerHTML ?? "");

  const imgixUrl =
    "https://connox.imgix.net/media/Gutscheine/" +
    GiftLinkLocales[getShopId()] +
    "?blend-mode=multiply&blend=" +
    imgURL +
    "&blend-h=600&blend-w=600&blend-x=980&blend-y=250&txt=" +
    productName +
    "&txt-width=1000&txt-fit=max&txt-align=bottom,left&txt-pad=80&txt-size=54";

  const toggleInfo = () => {
    setInfoOpen(!infoOpen);
  };

  const onLinkClicked = () => {
    Tracking.sendABTestSeenEvent("Geschenkgutschein geklickt");
  };

  if (!productName || !imgURL) {
    return null;
  }

  return (
    <div className={styles.wrapper}>
      <a href={imgixUrl} target="_blank" rel="noreferrer" onClick={onLinkClicked}>
        <span className={styles.giftIcon} />
        {t("Produkt als Gutscheinkarte ausdrucken")}
      </a>
      <div className={styles.infoWrapper}>
        <span className={styles.infoIcon} onClick={toggleInfo} />
        {infoOpen && <span className={styles.info}>{t("GeschenkInfoTextInPDP")}</span>}
      </div>
    </div>
  );
};

const GiftLinkLocales: {[key: number]: string} = {
  100001: "Connox-Geschenkkarte-zum-Ausdrucken.jpg",
  100009: "Connox-Geschenkkarte-zum-Ausdrucken.jpg",
  100017: "Connox-Geschenkkarte-zum-Ausdrucken.jpg",
  100027: "Carte-cadeau-Connox-a-imprimer-CHFR.jpg",
  100005: "Printable-Connox-Gift-Card-COM.jpg",
  100020: "Printable-Connox-Gift-Card-UK.jpg",
  100008: "Carte-cadeau-Connox-a-imprimer-FR.jpg",
  100022: "Connox-gavekort-til-print-DK.jpg",
  100029: "Connox-cadeaubon-om-te-printen-NL.jpg",
};

export default GiftBlock;
